import Vue from 'vue';
import Axios from 'axios';
import gsap from 'gsap';

Vue.component('search-block', {
    props: {
        initialQuery: {
            type: String,
            default: ''
        },
        initialPage: {
            type: String,
            default: '1'
        }
    },
    data: function() {
        return {
            searchResults: [],
            emptyResult: true,
            resultsCount: null,
            currentPage: parseInt(this.initialPage),
            loading: true,
            searchQuery: this.initialQuery,
            wait: 500,
            elapsed: 0,
            options: [
                {
                    value: 'theme',
                    label: "Thema's"
                },
                {
                    value: 'news',
                    label: 'Nieuws'
                },
                {
                    value: 'vision',
                    label: 'Standpunten'
                }
            ],
            types: []
        };
    },

    computed: {
        pages: function() {
            if (this.resultsCount % 12 == 0) {
                return this.resultsCount / 12;
            }
            return Math.ceil(this.resultsCount / 12);
        },
        typesQuery: function() {
            let query = '';
            for (const key in this.typesObj) {
                query += '&' + key + '=' + this.typesObj[key];
            }
            return query;
        },
        typesObj: function() {
            const obj = {};
            this.types.forEach(item => {
                obj[item] = true;
            });
            return obj;
        }
    },

    watch: {
        currentPage: function() {
            this.getItems();
        },
        searchQuery: function(val) {
            if (this.elapsed != 0) {
                clearInterval(this.elapsed);
            }
            if (val != '') {
                this.elapsed = setInterval(this.getItems, this.wait);
            } else {
                this.searchResults = [];
                this.resultsCount = 0;
            }
            this.emptyResult = false;
        },

        typesQuery: function() {
            this.currentPage = 1;
            this.getItems();
        }
    },

    mounted() {
        this.getItems();
    },

    methods: {
        getItems: function() {
            clearInterval(this.elapsed);
            this.loading = true;
            this.searchResults = [];
            Axios.get(
                '/umbraco/api/search/search?q=' +
                    this.searchQuery +
                    '&page=' +
                    this.currentPage +
                    this.typesQuery +
                    '&v=' +
                    Date.now() +
                    '&contentid=' +
                    document
                        .getElementsByTagName('body')[0]
                        .getAttribute('data-root-page')
            ).then(response => {
                if (response.status == 200 && response.data.data) {
                    this.searchResults = response.data.data;
                    this.resultsCount = response.data.results;
                    this.emptyResult =
                        response.data.results != 0 ? false : true;
                }
                this.loading = false;
                gsap.to(window, 1, {
                    scrollTo: { y: 0, autoKill: true },
                    delay: 0,
                    ease: 'cubic.easeOut'
                });
            });
        },

        getColorClass: function(item) {
            if (item !== null && item.ParentColor !== null) {
                return 'card--' + item.ParentColor.Label;
            }
        },

        trySubtractFive: function() {
            if (this.currentPage > 5) {
                this.currentPage = this.currentPage - 5;
            } else {
                this.currentPage = 1;
            }
        },

        tryAddFive: function() {
            if (this.currentPage < this.pages - 5) {
                this.currentPage = this.currentPage + 5;
            } else {
                this.currentPage = this.pages;
            }
        },

        toggleFilter: function(filter) {
            !(this.types.indexOf(filter) != -1)
                ? this.types.push(filter)
                : this.types.splice(this.types.indexOf(filter), 1);
        },

        beforeEnter: function(el) {
            el.style.opacity = 0;
        },
        enter: function(el, done) {
            const delay = el.dataset.index * 100;
            setTimeout(function() {
                gsap.to(el, 0.5, {
                    opacity: 1,
                    onComplete: done,
                    delay: 0.3
                });
            }, delay);
        },
        leave: function(el, done) {
            el.style.opacity = 0;
            done();
        }
    }
});
